export const REQUEST_COMPANY_DETAILS = "REQUEST_COMPANY_DETAILS";
export const SET_COMPANY_DETAILS = "SET_COMPANY_DETAILS";
export const REVOKE_COMPANY_DETAILS = "REVOKE_COMPANY_DETAILS";
export const RESET_COMPANY_DETAILS = "RESET_COMPANY_DETAILS";

export const CHANGE_COMPANY_MODALS = "CHANGE_COMPANY_MODALS";

export const REQUEST_COMPANY_TEAM = "REQUEST_COMPANY_TEAM";
export const SET_COMPANY_TEAM = "SET_COMPANY_TEAM";
export const REVOKE_COMPANY_TEAM = "REVOKE_COMPANY_TEAM";
export const RESET_COMPANY_TEAM = "RESET_COMPANY_TEAM";

export const REQUEST_COMPANY_RECEIPTS = "REQUEST_COMPANY_RECEIPTS";
export const SET_COMPANY_RECEIPTS = "SET_COMPANY_RECEIPTS";
export const REVOKE_COMPANY_RECEIPTS = "REVOKE_COMPANY_RECEIPTS";
export const RESET_COMPANY_RECEIPTS = "RESET_COMPANY_RECEIPTS";

export const REQUEST_COMPANY_SUBSCRIPTION = "REQUEST_COMPANY_SUBSCRIPTION";
export const SET_COMPANY_SUBSCRIPTION = "SET_COMPANY_SUBSCRIPTION";
export const REVOKE_COMPANY_SUBSCRIPTION = "REVOKE_COMPANY_SUBSCRIPTION";
export const RESET_COMPANY_SUBSCRIPTION = "RESET_COMPANY_SUBSCRIPTION";

export const REQUEST_UPDATE_COMPANY_IMAGE = "REQUEST_UPDATE_COMPANY_IMAGE";
export const REVOKE_UPDATE_COMPANY_IMAGE = "REVOKE_UPDATE_COMPANY_IMAGE";
export const RESET_UPDATE_COMPANY_IMAGE = "RESET_UPDATE_COMPANY_IMAGE";
export const GRANT_UPDATE_COMPANY_IMAGE = "GRANT_UPDATE_COMPANY_IMAGE";

export const REQUEST_DELETE_COMPANY_IMAGE = "REQUEST_DELETE_COMPANY_IMAGE";
export const REVOKE_DELETE_COMPANY_IMAGE = "REVOKE_DELETE_COMPANY_IMAGE";
export const RESET_DELETE_COMPANY_IMAGE = "RESET_DELETE_COMPANY_IMAGE";
export const GRANT_DELETE_COMPANY_IMAGE = "GRANT_DELETE_COMPANY_IMAGE";

export const REQUEST_COMPANY_IMAGE = "REQUEST_COMPANY_IMAGE";
export const REVOKE_COMPANY_IMAGE = "REVOKE_COMPANY_IMAGE";
export const RESET_COMPANY_IMAGE = "RESET_COMPANY_IMAGE";
export const GRANT_COMPANY_IMAGE = "GRANT_COMPANY_IMAGE";

export const REQUEST_SUBSCRIPTION_DELETION = "REQUEST_SUBSCRIPTION_DELETION";
export const GRANT_SUBSCRIPTION_DELETION = "GRANT_SUBSCRIPTION_DELETION";
export const REVOKE_SUBSCRIPTION_DELETION = "REVOKE_SUBSCRIPTION_DELETION";
export const RESET_SUBSCRIPTION_DELETION = "RESET_SUBSCRIPTION_DELETION";

export const REQUEST_SEND_INVITATION = "REQUEST_SEND_INVITATION";
export const GRANT_SEND_INVITATION = "GRANT_SEND_INVITATION";
export const REVOKE_SEND_INVITATION = "REVOKE_SEND_INVITATION";
export const RESET_SEND_INVITATION = "RESET_SEND_INVITATION";

export const REQUEST_DELETE_COMPANY = "REQUEST_DELETE_COMPANY";
export const GRANT_DELETE_COMPANY = "GRANT_DELETE_COMPANY";
export const REVOKE_DELETE_COMPANY = "REVOKE_DELETE_COMPANY";
export const RESET_DELETE_COMPANY = "RESET_DELETE_COMPANY";

export const REQUEST_DELETE_MEMBER = "REQUEST_DELETE_MEMBER";
export const GRANT_DELETE_MEMBER = "GRANT_DELETE_MEMBER";
export const REVOKE_DELETE_MEMBER = "REVOKE_DELETE_MEMBER";
export const RESET_DELETE_MEMBER = "RESET_DELETE_MEMBER";

export const SET_ACTIVE_EDIT_MEMBER = "SET_ACTIVE_EDIT_MEMBER";
export const RESET_ACTIVE_EDIT_MEMBER = "RESET_ACTIVE_EDIT_MEMBER";

export const REQUEST_CHANGE_MEMBER = "REQUEST_CHANGE_MEMBER";
export const GRANT_CHANGE_MEMBER = "GRANT_CHANGE_MEMBER";
export const REVOKE_CHANGE_MEMBER = "REVOKE_CHANGE_MEMBER";
export const RESET_CHANGE_MEMBER = "RESET_CHANGE_MEMBER";

export const REQUEST_UPDATE_COMPANY_DETAILS = "REQUEST_UPDATE_COMPANY_DETAILS";
export const REVOKE_UPDATE_COMPANY_DETAILS = "REVOKE_UPDATE_COMPANY_DETAILS";
export const RESET_UPDATE_COMPANY_DETAILS = "RESET_UPDATE_COMPANY_DETAILS";
export const GRANT_UPDATE_COMPANY_DETAILS = "GRANT_UPDATE_COMPANY_DETAILS";

export const REQUEST_COMPANY_PAYMENT_METHODS =
  "REQUEST_COMPANY_PAYMENT_METHODS";
export const SET_COMPANY_PAYMENT_METHODS = "SET_COMPANY_PAYMENT_METHODS";
export const REVOKE_COMPANY_PAYMENT_METHODS = "REVOKE_COMPANY_PAYMENT_METHODS";
export const RESET_COMPANY_PAYMENT_METHODS = "RESET_COMPANY_PAYMENT_METHODS";

export const REQUEST_DELETE_PAYMENT_METHOD = "REQUEST_DELETE_PAYMENT_METHOD";
export const GRANT_DELETE_PAYMENT_METHOD = "GRANT_DELETE_PAYMENT_METHOD";
export const REVOKE_DELETE_PAYMENT_METHOD = "REVOKE_DELETE_PAYMENT_METHOD";
export const RESET_DELETE_PAYMENT_METHOD = "RESET_DELETE_PAYMENT_METHOD";

export const SET_ACTIVE_PAYMENT_METHOD = "SET_ACTIVE_PAYMENT_METHOD";
export const RESET_ACTIVE_PAYMENT_METHOD = "RESET_ACTIVE_PAYMENT_METHOD";

export const SET_ACTIVE_SUBSCRIPTION = "SET_ACTIVE_SUBSCRIPTION";
export const RESET_ACTIVE_SUBSCRIPTION = "RESET_ACTIVE_SUBSCRIPTION";

export const REQUEST_ADD_PAYMENT_METHOD = "REQUEST_ADD_PAYMENT_METHOD";
export const GRANT_ADD_PAYMENT_METHOD = "GRANT_ADD_PAYMENT_METHOD";
export const REVOKE_ADD_PAYMENT_METHOD = "REVOKE_ADD_PAYMENT_METHOD";
export const RESET_ADD_PAYMENT_METHOD = "RESET_ADD_PAYMENT_METHOD";

export const REQUEST_UPDATE_PAYMENT_METHOD = "REQUEST_UPDATE_PAYMENT_METHOD";
export const GRANT_UPDATE_PAYMENT_METHOD = "GRANT_UPDATE_PAYMENT_METHOD";
export const REVOKE_UPDATE_PAYMENT_METHOD = "REVOKE_UPDATE_PAYMENT_METHOD";
export const RESET_UPDATE_PAYMENT_METHOD = "RESET_UPDATE_PAYMENT_METHOD";

export const REQUEST_UPDATE_LICENSE_QUANTITY =
  "REQUEST_UPDATE_LICENSE_QUANTITY";
export const GRANT_UPDATE_LICENSE_QUANTITY = "GRANT_UPDATE_LICENSE_QUANTITY";
export const REVOKE_UPDATE_LICENSE_QUANTITY = "REVOKE_UPDATE_LICENSE_QUANTITY";
export const RESET_UPDATE_LICENSE_QUANTITY = "RESET_UPDATE_LICENSE_QUANTITY";

export const REQUEST_COMPANY_CHANNELS = "REQUEST_COMPANY_CHANNELS";
export const SET_COMPANY_CHANNELS = "SET_COMPANY_CHANNELS";
export const REVOKE_COMPANY_CHANNELS = "REVOKE_COMPANY_CHANNELS";
export const RESET_COMPANY_CHANNELS = "RESET_COMPANY_CHANNELS";
